import { IAlertProps } from 'native-base';
import { ReactNode } from 'react';

import { NoticeTheme } from 'app/generated/hygraph';
import type { NoticeAlertStatus } from 'app/services/NoticeHelper';

import NoticeCard from './NoticeCard';

export type CPAlertProps = Omit<IAlertProps, 'status'> & {
  children?: ReactNode;
  title?: string;
  status?: NoticeAlertStatus;
  theme?: NoticeTheme;
  variant?: 'default' | 'simple' | 'mini';
  collapsible?: boolean;
  initialOpen?: boolean;
  action?: { label: string; onPress: () => void };
  onExpand?: () => void;
};

export default function CPAlert(props: CPAlertProps) {
  return <NoticeCard {...props} />;
}
